module.exports = __webpack_public_path__ + "img/logo_site_white.257260a6.webp";